import {
  SchoolSearchArgs,
  withBooleanFeatureFlag,
  Property,
  getPropertyNearbySchools,
} from '@greystar/lib';
import { PropertyDetailsGreatSchoolsProps, SchoolsGallery } from '@greystar/ui';
import {
  Text as JssText,
  GetStaticComponentProps,
  withDatasourceCheck,
} from '@sitecore-jss/sitecore-jss-nextjs';
import React, { JSX } from 'react';

const PropertyDetailsGreatSchools = (props: PropertyDetailsGreatSchoolsProps): JSX.Element => {
  if (!props.data?.schools?.length) {
    return <></>;
  }

  return (
    <section>
      <div>
        <h2>
          <JssText field={props.fields.title} />
        </h2>
        <SchoolsGallery schools={props.data.schools} />
        <p>
          School data provided by{' '}
          <a href="https://www.greatschools.org" rel="nofollow noopener" target="_blank">
            GreatSchools
          </a>
        </p>
      </div>
    </section>
  );
};

export const getStaticProps: GetStaticComponentProps = async (
  rendering,
  layoutData
): Promise<PropertyDetailsGreatSchoolsProps> => {
  const props = rendering as unknown as PropertyDetailsGreatSchoolsProps;
  const property = layoutData.sitecore.context.property as Property;

  if (!property?.location || !process.env.GreatSchoolsKey) {
    return {
      ...props,
      data: {
        schools: [],
        notFound: true,
      },
      flagKey: rendering.componentName,
      isPageEditing: layoutData.sitecore.context.pageEditing,
    };
  }

  const schoolSearchArgs: SchoolSearchArgs = {
    limit: props.fields.limit.value,
    renderLimit: props.fields.renderLimit.value,
    distance: props.fields.distance.value,
    showSchoolsWithoutRating: props.fields.showSchoolsWithoutRating.value,
  };

  const schools = await getPropertyNearbySchools(property, schoolSearchArgs);

  return {
    ...props,
    data: {
      schools,
      notFound: false,
    },
    flagKey: rendering.componentName,
    isPageEditing: layoutData.sitecore.context.pageEditing,
  };
};

export default withDatasourceCheck()<PropertyDetailsGreatSchoolsProps>(
  withBooleanFeatureFlag(PropertyDetailsGreatSchools)
);
